import { ErrorMessage, Field } from "formik";

const TextareaForm = ({
  name,
  touched,
  errors,
  handleBlur,
  label,
  placeholder,
  style = "col-md-6",
  required = true,
}) => {
  return (
    <div className={`${style} mb-3`}>
      <label
        className={`form-label ${required ? "required-label" : ""} `}
        htmlFor="package_description_arabic"
      >
        {label}
      </label>
      <Field
        as="textarea"
        name={name}
        className={`form-control ${
          touched && errors ? "custom-invalid-input" : ""
        }`}
        placeholder={placeholder}
        onBlur={handleBlur}
      />
      <ErrorMessage name={name} component="div" className="invalid-feedback" />
    </div>
  );
};

export default TextareaForm;
